import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { clientSchema } from '@basehub/data/replicache/index'
import { useIsExternalVisitor } from './use-user-role'

export const useDashboardPresenceQuery = (teamId: string | undefined) => {
  const isExternalVisitor = useIsExternalVisitor()

  return useQuery(
    ['team-presence', teamId],
    async () => {
      const res = await fetch(`/api/teams/${teamId}/presence`)
      const data = await res.json()
      const parsed = z
        .object({
          others: z.array(clientSchema.extend({ repoId: z.string() })),
        })
        .parse(data)
      return parsed.others
    },
    { enabled: Boolean(teamId) && !isExternalVisitor, refetchInterval: 3000 }
  )
}
